import axios from "axios";
import { VEHICLES_URL, ROUTE_URL } from "../../../../constants/config";

export const getAllVehicles = (params) => {
  return axios.get(`${VEHICLES_URL}/list`, { params: params });
};

export const getVehicleById = (id) => {
  return axios.get(`${VEHICLES_URL}/${id}`);
};

export const createVehicle = (vehicle) => {
  return axios.post(`${VEHICLES_URL}`, vehicle);
};

export const updateVehicle = (vehicle) => {
  return axios.put(`${VEHICLES_URL}/${vehicle.id}`, vehicle);
};

export const deleteVehicle = (id) => {
  return axios.delete(`${VEHICLES_URL}/${id}`);
};

export const updateStatus = (id, status) => {
  return axios.patch(`${VEHICLES_URL}/${id}`, { status });
};

export const getAllRoutes = (params) => {
  return axios.get(`${ROUTE_URL}/list`, { params });
};

export const getDeliveryStats = () => {
  return axios.get(`${ROUTE_URL}/stats`);
};

export const getRouteById = (id) => {
  return axios.get(`${ROUTE_URL}/${id}`);
};

export const deleteRoute = (id) => {
  return axios.delete(`${ROUTE_URL}/${id}`);
};

export const routeCancellation = (payload) => {
  return axios.post(`${ROUTE_URL}/cancel`, payload);
};

export const forceCompleteRoute = (routeId) => {
  return axios.post(`${ROUTE_URL}/force-complete`, { route_id: routeId });
};